import type { Variants } from "motion/react";

/**
 * Animation variants for the main trigger button icon rotation.
 */
export const triggerIconVariants: Variants = {
  closed: {
    rotate: 0,
    transition: {
      duration: 0.2,
      ease: "linear",
    },
  },
  open: {
    rotate: 45,
    transition: {
      duration: 0.2,
      ease: "linear",
    },
  },
};
